import { render, staticRenderFns } from "./Twitter.vue?vue&type=template&id=463cbbba&scoped=true&"
import script from "./Twitter.vue?vue&type=script&lang=js&"
export * from "./Twitter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463cbbba",
  null
  
)

export default component.exports